import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from 'src/components/common/PageHeader';
import { PageContainer } from 'src/components/common/PageContainer';
import { useToast } from 'src/hooks/use-toast';
import {
  useCreateTestGroup,
  useUpdateTestGroup,
} from 'src/services/api/mutations/testMutations';
import { NewTestGroup } from '../NewTestGroup/NewTestGroup';

const TestGroupForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const createTestGroup = useCreateTestGroup();
  const updateTestGroup = useUpdateTestGroup();

  const isEditMode = Boolean(id);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      if (isEditMode) {
        await updateTestGroup.mutateAsync({ id, data: formData });
        toast({
          title: 'Success',
          description: 'Test group updated successfully',
          variant: 'success',
        });
      } else {
        await createTestGroup.mutateAsync(formData);
        toast({
          title: 'Success',
          description: 'Test group created successfully',
          variant: 'success',
        });
        navigate('/tests', { state: { activeTab: 'groups' } });
      }
    } catch (error) {
      toast({
        title: 'Error',
        description:
          error?.message || 'Failed to save test group. Please try again.',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/tests', { state: { activeTab: 'groups' } });
  };

  const breadcrumbs = [
    { label: 'Test Management', href: '/tests' },
    { label: 'Test Groups', href: '/tests', state: { activeTab: 'groups' } },
    { label: isEditMode ? 'Edit Group' : 'New Group', href: '#' },
  ];

  return (
    <div>
      <PageHeader breadcrumbs={breadcrumbs} />

      <PageContainer>
        <div className="max-w-2xl mx-auto">
          <NewTestGroup
            onSubmit={handleSubmit}
            onClose={handleCancel}
            initialData={isEditMode ? { id: parseInt(id, 10) } : null}
            loading={loading}
          />
        </div>
      </PageContainer>
    </div>
  );
};

export default TestGroupForm;
